export default {"src":"/_next/static/media/ra-fill-phone.2b1dc12a.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};